import { render, staticRenderFns } from "./SystemTagPicker.vue?vue&type=template&id=5176571c&scoped=true"
import script from "./SystemTagPicker.vue?vue&type=script&lang=ts"
export * from "./SystemTagPicker.vue?vue&type=script&lang=ts"
import style0 from "./SystemTagPicker.vue?vue&type=style&index=0&id=5176571c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5176571c",
  null
  
)

export default component.exports